<template>
    <div>
        <l-space :size="1" />
        <h4>{{ $t("surveys.actionItemModal.labelComments") }}</h4>
        <hr />

        <!-- Comments -->
        <div v-if="actionItem.comments && actionItem.comments.length">
            <div
                v-for="comment in actionItem.comments"
                v-show="comment.created_at"
                :key="comment._id"
            >
                <div class="tw-flex tw-space-x-8 tw-items-center tw-justify-center tw-group">
                    <!-- Sender Picture -->
                    <div class="tw-flex-grow-0">
                        <l-profile-picture
                            :user="comment.sender"
                            :show-popover-name="true"
                            size="m"
                        />
                    </div>
                    <!--/Sender Picture -->

                    <!-- Comment Content -->
                    <div class="tw-flex-1">
                        <span
                            class="fake-link clickable"
                            tabindex="0"
                            @click="visitProfile({ userId: comment.sender._id })"
                            @keyup.enter="visitProfile({ userId: comment.sender._id })"
                        >
                            <strong>
                                {{ comment.sender.firstname + " " + comment.sender.lastname }}
                            </strong>
                        </span>
                        <span class="color-grey l-default-margin-s">
                            {{ comment.created_at | moment("MMM DD, YYYY") }}
                        </span>
                        <span
                            v-show="comment.sender._id === currentUser._id"
                            v-b-popover.hover.top="{
                                content: $t('surveys.actionItemModal.labelRemove'),
                            }"
                            class="pull-right clickable"
                            tabindex="0"
                            @click="deleteComment(comment)"
                            @keyup.enter="deleteComment(comment)"
                        >
                            <i class="fal fa-trash color-grey"></i>
                        </span>
                        <br />
                        <span v-html="comment.content"></span>
                    </div>
                    <!--/Comment Content -->
                </div>
                <l-space :size="1" />
            </div>
        </div>
        <!-- /Comment -->

        <!-- Comment Input -->
        <l-rich-text-editor
            v-if="actionItem._id && actionItem.type !== 'surveyActionItemSuggestion'"
            v-model="newComment"
            :content="newComment"
        ></l-rich-text-editor>
        <!--/Comment Input -->

        <l-space :size="1" />
        <l-text-alert v-if="error" type="warning" :text="error" />

        <!-- Buttons -->
        <div v-if="actionItem.type !== 'surveyActionItemSuggestion'" class="row">
            <div>
                <div class="col-md-3 col-md-offset-9">
                    <button
                        class="btn btn-sm btn-primary btn-block btn-raised"
                        @click="createActionItemComment()"
                    >
                        {{ $t("surveys.actionItemModal.buttonSend") }}
                    </button>
                </div>
            </div>
        </div>
        <!--- Buttons -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import icon from "@/img/icons/surveys.png";
import relaxIcon from "@/img/icons/relax.png";
import LProfilePicture from "@/components/LProfilePicture";

import LRichTextEditor from "@/components/LRichTextEditor";

import LSpace from "@/components/LSpace";
import LTextAlert from "@/components/LTextAlert";

export default {
    components: {
        LProfilePicture,
        LRichTextEditor,
        LSpace,
        LTextAlert,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
        actionItem: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            newComment: "",
            error: "",
        };
    },
    computed: {
        ...mapGetters({
            currentUser: "users/current/user",
        }),
    },

    created() {
        this.icon = icon;
        this.relaxIcon = relaxIcon;
    },
    methods: {
        showError(error) {
            this.error = error;
            setTimeout(() => {
                this.error = "";
            }, 5000);
        },
        createActionItemComment() {
            this.$store
                .dispatch("surveys/actionItemComment/create", {
                    payload: {
                        survey: this.survey._id,
                        actionItem: this.actionItem._id,
                        content: this.newComment,
                        type: "actionItem",
                    },
                })
                .then(() => {
                    this.newComment = "";
                    this.$emit("change", this.actionItem._id); // reload actionItem
                })
                .catch(({ response }) => {
                    if (response?.data?.message) {
                        this.showError(response.data.message);
                    }
                });
        },
        deleteComment(comment) {
            this.$store
                .dispatch("surveys/actionItemComment/delete", {
                    payload: {
                        survey: this.survey._id,
                        actionItem: this.actionItem,
                        comment,
                    },
                })
                .then(() => {
                    this.$emit("change", this.actionItem._id); // reload actionItem
                });
        },
    },
};
</script>
